import { create } from 'zustand';
import type { UserProfile, UserRole } from '@/lib/types';

/**
 * App-side identity store. Populated by the backend's `/v1/auth/login`
 * response (token persisted by `lib/api`, profile + isAuthenticated written
 * here). The wallet handshake itself lives in the backend — see SPEC §10.
 */

export type Rail1LinkStatus = 'idle' | 'pending' | 'linked' | 'failed';

interface AuthState {
  isAuthenticated: boolean;
  profile: UserProfile | null;
  rail1LinkStatus: Rail1LinkStatus;
  /** Set when `/link-rail1` reports this session belongs to an admin/superadmin
   *  account (no participant profile) — drives `AdminGateOverlay`. */
  adminGateRole: UserRole | null;
  setAuthenticated: (value: boolean) => void;
  setProfile: (profile: UserProfile | null) => void;
  setRail1LinkStatus: (status: Rail1LinkStatus) => void;
  setAdminGateRole: (role: UserRole | null) => void;
  reset: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  isAuthenticated: false,
  profile: null,
  rail1LinkStatus: 'idle',
  adminGateRole: null,
  setAuthenticated: (isAuthenticated) => set({ isAuthenticated }),
  setProfile: (profile) => set({ profile }),
  setRail1LinkStatus: (rail1LinkStatus) => set({ rail1LinkStatus }),
  setAdminGateRole: (adminGateRole) => set({ adminGateRole }),
  reset: () =>
    set({ isAuthenticated: false, profile: null, rail1LinkStatus: 'idle', adminGateRole: null }),
}));
